var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.title),expression:"title"}],staticClass:"btn btn-info",attrs:{"href":_vm.src,"rel":_vm.rel}},[_c('i',{staticClass:"ti-image"})])
}
var staticRenderFns = []

export { render, staticRenderFns }